import type { ModuleAccess } from '@/data-sources/contract';

/** Whether the signed-in person may open a sidebar module (`bootstrap.modules`). */
export function canOpen(modules: ModuleAccess, navItem: string | undefined): boolean {
  if (modules === 'all' || navItem === undefined) return true;
  return modules.includes(navItem);
}

/** The sidebar items to draw: the tree's pages the person may open. */
export function openNavItems(
  visible: ReadonlySet<string>,
  modules: ModuleAccess,
): ReadonlySet<string> {
  if (modules === 'all') return visible;
  return new Set([...visible].filter((id) => modules.includes(id)));
}
